import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Task } from '@contracts/interfaces/task.interface';
import { ConnectionService } from './connection.service';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {


    constructor(private http: HttpClient,
        private connectionService: ConnectionService ) {}
    
      
    renderFile(templateFile: string, templateVariables: any) {
        return this.http.post(this.connectionService.address + "/template-service/render-file", { templateFile, templateVariables });
    }

    render(content: string, templateVariables: any) {
        return this.http.post(this.connectionService.address + "/template-service/render", { content, templateVariables });
    }
}
